export const getFileExtensionFromName = (fileName: string): string => {
    if (!fileName) return "";

    const trimmed = fileName.trim();

    // Ignore files like ".gitignore" (no extension)
    if (trimmed.startsWith(".") && !trimmed.slice(1).includes(".")) return "";

    const lastDot = trimmed.lastIndexOf(".");
    if (lastDot <= 0 || lastDot === trimmed.length - 1) return "";

    return `.${trimmed.slice(lastDot + 1).toLowerCase()}`;
};
